import { Message } from '@/mocks/app/mockChatData';

/**
 * Traduz uma mensagem exibida no chat para os IDs REAIS que ela representa na store.
 *
 * O balão de álbum (`type: 'media_grid'`) é uma mensagem VIRTUAL criada em
 * `ChatConversation.groupConsecutiveMedia` para agrupar 4+ mídias consecutivas. Ela recebe
 * um ID sintético (`grid-<idDaPrimeira>`) que nunca existe em `store.messages` — por isso
 * qualquer ação que filtre a store por ID (encaminhar, apagar/favoritar em massa) precisa
 * resolver o álbum nas mensagens reais que ele contém antes de agir.
 */
export function resolveSelectableMessageIds(message: Message): string[] {
    const gridMessages = (message as Message & { gridMessages?: Message[] }).gridMessages;

    if (Array.isArray(gridMessages) && gridMessages.length > 0) {
        return gridMessages.map(m => m.id);
    }

    return [message.id];
}
